import { Box, Grid } from "@mui/material"
import GstPanInput from "../../FirmOnboarding/Components/GstPanInput"

const GSTInput = () => {
  return (
    <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} md={6}>
            <GstPanInput 
              justify="flex-start"
              confirmNavigation='/my-account/confirm'
            />
          </Grid>
        </Grid>
        
    </Box>
        
  )
}

export default GSTInput